import { Address } from '@amfam/policy/models';
import { AddressPipe } from '@amfam/policy/pipes';

export class AddressCompare {
  public static equal(x: Address, y: Address): boolean {
    return AddressCompare.compare(x, y) === 0;
  }

  public static compare(x: Address, y: Address): number {
    const a = new AddressPipe().transform(x, 'long').toUpperCase();
    const b = new AddressPipe().transform(y, 'long').toUpperCase();

    if (a === b) {
      return 0;
    } else if (a > b) {
      return 1;
    } else {
      return -1;
    }
  }
}
